const topics = [
  { label: '动作大片', count: '2.3w+', hot: true },
  { label: '悬疑烧脑', count: '1.8w+', hot: true },
  { label: '高分韩剧', count: '1.6w+', hot: true },
  { label: '国产精品', count: '2.1w+', hot: false },
  { label: '科幻巨制', count: '1.5w+', hot: true },
  { label: '动漫热血', count: '1.2w+', hot: false },
  { label: '喜剧搞笑', count: '9800+', hot: false },
  { label: '纪录纪实', count: '6500+', hot: false },
  { label: '经典重温', count: '1.1w+', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="w-full py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            热门话题
          </h2>
          <p className="text-foreground-600 text-sm mt-2">大家都在看的热门分类，发现你的下一部心头好</p>
        </div>

        <div className="flex flex-wrap gap-3">
          {topics.map((topic, i) => (
            <span
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium cursor-pointer transition-colors whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-100 text-accent-700 hover:bg-accent-200'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/60'
              }`}
            >
              {topic.hot && (
                <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                  <i className="ri-fire-line text-xs"></i>
                </span>
              )}
              {topic.label}
              <span className="text-xs opacity-60 ml-0.5">{topic.count}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}